import { TableRow, Tag, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { usePathParam } from '@chilecompra/react-kit'
import { VOID_STATES } from '../../../config/settings/constant'
import { PATH_PARAM } from '../../../config/settings/regexes'
import routes from '../../../config/settings/routes'
import { onSetInitialState } from '../../Sanction/Sanction.actions'
import { Container, Link, TableCell } from '../HistoricalSanctionsList.styles'

/**
 * A single historical sanction row.
 */
const SanctionRow = ({ disabled = false, isLast, item, onFetchSanctionVoidInfo, onOpenSanctionVoidDialog }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const dni = usePathParam('rut')

  const cellProps = { disableBottomBorder: !isLast, padding: '12px 16px' }

  const handleDetailSantion = (event, isVoid) => {
    event.preventDefault()

    if (isVoid) {
      onFetchSanctionVoidInfo()
      onOpenSanctionVoidDialog()

      return
    }

    dispatch(onSetInitialState())
    navigate(`${routes.sanctionDetails.replace(PATH_PARAM, dni).replace(PATH_PARAM, item.id)}?h=true`)
  }

  return (
    <TableRow height="80px">
      <TableCell {...cellProps}>
        <Typography fontWeight="bold" variant="body2">
          {item.purchaseOrderCode}
        </Typography>

        <Typography color="black3" fontSize="13px" variant="body2">
          {item.purchaseOrderName}
        </Typography>
      </TableCell>

      <TableCell {...cellProps}>
        <Typography fontWeight="bold" variant="body2">
          {item.organization}
        </Typography>
      </TableCell>

      <TableCell {...cellProps}>{item.acceptanceDate}</TableCell>

      <TableCell {...cellProps}>
        <Container>
          <Tag color={item.isVoid ? 'default' : 'info'} text={item.isVoid ? VOID_STATES.VOIDED : VOID_STATES.ACTIVE} />
        </Container>
      </TableCell>

      <TableCell {...cellProps}>
        <Link disabled={disabled} onClick={event => handleDetailSantion(event, item.isVoid)} to="#">
          Ver detalle
        </Link>
      </TableCell>
    </TableRow>
  )
}

SanctionRow.propTypes = {
  disabled: PropTypes.bool,
  isLast: PropTypes.bool,
  item: PropTypes.object,
  onFetchSanctionVoidInfo: PropTypes.func.isRequired,
  onOpenSanctionVoidDialog: PropTypes.func.isRequired
}

export default SanctionRow
